import { isValidElement, memo, useMemo } from 'react'
import { SxProps } from '@mui/material'
import { Text, TextProps } from '@/components/Data'
import { useTranslations } from '@/core/translation'
import { bannerHeadingStyles as styles } from './BannerHeading.style'
import { BannerHeadingProps } from './BannerHeading.types'
import { useDomainInfo } from '@/utils'

function BannerHeading({ heading, headingProps = {} }: BannerHeadingProps) {
  const t = useTranslations('banner')
  const { isFanaticsDomain } = useDomainInfo()
  const { sx: headingSx, ...otherHeadingProps } = headingProps

  const isHeadingReactNode = isValidElement(heading)

  const textProps: TextProps = useMemo(
    () => ({
      sx: [styles.heading, isFanaticsDomain && styles.headingFanatics, headingSx] as SxProps,
      component: 'h1',
      ...otherHeadingProps,
    }),
    [isFanaticsDomain, headingSx, otherHeadingProps],
  )

  if (isHeadingReactNode) return <Text {...textProps}>{heading}</Text>

  return (
    <Text
      {...textProps}
      dangerouslySetInnerHTML={{
        __html: `<span>${heading ?? t('heading', { isFanaticsDomain: String(isFanaticsDomain) })}</span>`,
      }}
    />
  )
}

export default memo(BannerHeading)
